import axios from 'axios';

export let headers = {
  'Tenant-Access-Token': 'Y2JlZDFhYTY5NmYzYmRkMTgwOTRlZDIyMDBmM2E0Mzc=',
  'Tenant-Access-Key': 'kTrE9SG5ljWjOA',
};

export const BASE_URL = 'https://immersive-game-india.confirmu.com';

export const api = axios.create({
  baseURL: BASE_URL,
  headers: headers
});

